import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import { ExternalLink, Icon, type IconName } from '~/components';

import { footerContainerStyle, footerStyle, socialLinkStyle, socialsListStyle } from './AuthLayoutFooter.css';

const socials = ['website', 'instagram', 'facebook', 'linkedIn'] as const;

export const AuthLayoutFooter = () => {
  const { t } = useTranslation(['auth']);

  return (
    <div className={footerStyle}>
      <div className={footerContainerStyle}>
        <span>{t('auth:footer.trademark', { year: dayjs().year() })}</span>

        <div className={socialsListStyle}>
          {socials.map((social) => (
            <ExternalLink
              aria-label={t(`auth:footer.social.${social}.ariaLabel`)}
              className={socialLinkStyle}
              href={t(`auth:footer.social.${social}.link`)}
              key={social}
            >
              <Icon
                name={match(social)
                  .returnType<IconName>()
                  .with('website', () => 'Website')
                  .with('instagram', () => 'Instagram')
                  .with('facebook', () => 'Facebook')
                  .with('linkedIn', () => 'LinkedIn')
                  .exhaustive()}
                size={20}
              />
            </ExternalLink>
          ))}
        </div>
      </div>
    </div>
  );
};
